import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { SavedView, SavedViewContext, UpsertSavedViewRequest } from '../models/saved-view.model';

@Injectable({ providedIn: 'root' })
export class SavedViewService {
  private http = inject(HttpClient);
  private base = `${environment.apiBaseUrl}/api/v1/projects`;

  list(projectId: string, context: SavedViewContext): Observable<SavedView[]> {
    return this.http.get<SavedView[]>(`${this.base}/${projectId}/me/saved-views`, {
      params: new HttpParams().set('context', context),
    });
  }

  upsert(projectId: string, request: UpsertSavedViewRequest): Observable<SavedView> {
    return this.http.post<SavedView>(`${this.base}/${projectId}/me/saved-views`, request);
  }

  delete(projectId: string, context: SavedViewContext, name: string): Observable<void> {
    return this.http.delete<void>(`${this.base}/${projectId}/me/saved-views`, {
      params: new HttpParams().set('context', context).set('name', name),
    });
  }
}
